<template>
  <div>
    <div class="title">
      <span>{{$t('label.w10')}}{{data.Amount | cn}}</span>
      <!-- <span>{{$t('label.w11')}}</span> -->
      <span>{{$t('label.w12')}}</span>
    </div>
    <div class="content">
      <div class="rate">
        <p>{{(data.Rate).toFixed(1)}}%</p>
        <p>{{$t('label.w3')}}</p>
      </div>
      <div class="time">
        <p>
          <span class="n">{{time}}</span> {{isMon?$t('label.w14'):$t('label.w15')}}
        </p>
        <p>{{$t('label.w13')}}</p>
      </div>
    </div>
    <div class="progress">
      <div class="line">
        <p>￥{{data.CurrentAmount | money}}/￥{{data.Amount | money}}</p>
        <div class="p">
          <Progress :percent="data.Progress<1 && data.Progress!=0 ? 1:data.Progress" hide-info stroke-color="#749EFC"/>
        </div>
        <p>{{$t('other.w36').replace('{%}',data.InvestmentCount)}}</p>
      </div>
      <router-link class="btn" :to="{
        name:'borrowDetails',
        params:{id:data.Id}
      }">{{$t('btn.b38')}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props:['data'],
  computed:{
    isMon(){
      return this.data.LoanCycleValue>=30||this.data.LoanCycleValue==1;
    },
    time(){
      if(this.data.LoanCycleValue>=30) return this.data.LoanCycleValue/30;
      return this.data.LoanCycleValue
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(155, 159, 175, 1);
    line-height: 15px;
    border: 1px solid rgba(155, 159, 175, 1);
    min-width: 60px;
    height: 20px;
    line-height: 20px;
    border-radius: 2px;
    margin-right: 75px;
    text-align: center;
  }
  span:first-child {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(35, 35, 37, 1);
    line-height: 25px;
    border: none;
    margin: 0 0;
  }
}
.content {
  display: flex;
  margin-top: 15px;
  .rate {
    position: relative;
    p:first-child {
      font-size: 28px;
      min-width: 92px;
      height: 34px;
      font-family: DIN-Medium;
      font-weight: 500;
      color: rgba(255, 97, 6, 1);
      line-height: 34px;
    }
    p:last-child {
      height: 16px;
      font-size: 11px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(155, 159, 175, 1);
      line-height: 16px;
    }
    &::after {
      width: 1px;
      height: 49px;
      background: linear-gradient(
        180deg,
        rgba(249, 250, 249, 1) 0%,
        rgba(225, 225, 225, 1) 30%,
        rgba(225, 225, 225, 1) 70%,
        rgba(249, 250, 249, 1) 100%
      );
      content: "";
      position: absolute;
      right: -20px;
      top: 0;
    }
  }
  .time {
    margin-left: 40px;
    p:first-child {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 35, 37, 1);
      line-height: 20px;
      .n {
        width: 30px;
        height: 34px;
        font-size: 28px;
        font-family: DIN-Medium;
        font-weight: 500;
        color: rgba(35, 35, 37, 1);
        line-height: 34px;
      }
    }
    p:last-child {
      height: 16px;
      font-size: 11px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(155, 159, 175, 1);
      line-height: 16px;
    }
  }
}
.progress {
  display: flex;
  margin-top: 20px;
  align-items: flex-end;
  .line {
    p:first-child {
      height: 17px;
      font-size: 12px;
      font-family: DIN-Medium;
      font-weight: 500;
      color: rgba(155, 159, 175, 1);
      line-height: 15px;
    }
    .p {
      width: 148px;
    }
    p:last-child {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(155, 159, 175, 1);
      line-height: 17px;
    }
  }
  .btn {
    text-align: center;
    width: 77px;
    display: block;
    height: 26px;
    line-height: 26px;
    background: linear-gradient(
      90deg,
      rgba(249, 195, 72, 1) 0%,
      rgba(255, 129, 58, 1) 100%
    );
    color:#fff;
    border-radius: 15px;
    margin-left: 20px;
    color: #fff;
    cursor: pointer;
  }
}
</style>
